import React, {useState, useEffect, useMemo} from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';
import $ from 'jquery';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';

import DocumentFile from '../../../../constants/models/documentFile';
import {ToasterConfigurations} from '../../../../constants/toasterText/configurations';

import { uploadDocument, downloadDocument, deleteDocument, getDocuments } from '../../../../actions/facilita-api';

import { FileTypes, FiletypeToDisplayName } from '../../../../constants/utils/fileTypes';
import { UploadArea } from './../../../_common/upload-area';

import { ModalEditFolder } from './../../../_common/modalEditFolder';
import { ModalAddFile } from './../../../_common/modalAddFile';
import { ModalDelete } from './../../../_common/modalDelete';
import { ModalFileDescription } from './../../../_common/modalEditFileDescription'

import { ModalConfirmation } from './../../../_common/confirmation';
import { ModalPartager } from './../../../_common/partager';
import servicesUploading from './../../../../assets/images/placeholder/ServicesUploading-ilustration.png';

export const DossierBiblioteque = ({ files, userId, userRepresentativeId, isLoading }) => {
    const dispatch = useDispatch();
    const [selectedFileNames, setSelectedFileNames] = useState([]);

	const [currentPath, setCurrentPath] = useState("");
	const [pathLastElement, setPathLastElement] = useState([]);
	const [path, setPath] = useState([]);
	const [personalFiles, setPersonalFiles] = useState([]);
	const [selectedElementToDelete, setSelectedElementToDelete] = useState(undefined);
    const [selectedElementToEdit, setSelectedElementToEdit] = useState(undefined);
    const [modalForDefaultData, setModalForDefaultData] = useState(false);

    const [draggedFiles, setDraggedFiles] = useState([]);


    function browseFolder(folderPath){
		dispatch(getDocuments(userId, false, folderPath)).then((dbFiles) => {
			const persoFiles = dbFiles.map(x => new DocumentFile(x));
			setPersonalFiles([...persoFiles.filter(x => x.fileType === FileTypes.Other || x.fileType === FileTypes.Folder)]);

			let newPath = [];
			if(!R.isNil(folderPath)){
				const folderPathParts = folderPath.split('/');
				folderPathParts.map((folderPathPart, index) => {
					newPath.push({
						folderName: folderPathPart,
						fullPath: (newPath.length > 0 ? newPath[index - 1].fullPath + "/" : "") + folderPathPart
					});
				});
			}
			setPath(newPath)
		});
	}

	useEffect(() => {
        browseFolder();
    }, []);

	useEffect(() => {
		const lastElement = path[path.length - 1];
        setPathLastElement(lastElement);
		setCurrentPath(R.isNil(lastElement) ? undefined : lastElement.fullPath)
    }, [path]);

    const retraiteBaseLink = "https://www.lassuranceretraite.fr/portail-info/files/live/sites/pub/files/PDF/demande%20de%20retraite%20de%20r%c3%a9version.pdf";
    const retraiteComplementaireLink = "https://www.agirc-arrco.fr/wp-content/uploads/2021/10/Formulaire_de_reversion_AA.pdf";
    const mesDroitsSociauxLink = "https://www.mesdroitssociaux.gouv.fr/dd1pnds-ria/#destination/simu-foyer";

    files = files.filter(f => f.fileType !== FileTypes.ProfilePicture && f.fileType !== FileTypes.Signature);

    return (
			<article className="view-calc py-4">
				<div className="container-fluid h-inherit">
					<header className="flex-column gap-2 rounded">
						<div className="flex-row gap-2 align-items-center">
							<h4 className="h6 lh-copy text-uppercase font-weight-bolder my-auto mr-2">Vous pouvez dès à présent avancer les procédures requises en déposant les documents suivants :</h4>
							<div className="flex-row gap-2 ml-auto align-items-center">
								<div className="btn-group">
									<button type="button" className="btn btn-alert-warning btn-if p-1 rounded border-none" data-toggle="dropdown" aria-expanded="false">
										<i className="btn-icon eva eva-info-outline fs-root lh-1 btn-white-warning text-warning rounded btn-square no-event"></i>
										<span className="btn-text px-3">
											<span className="align-middle mr-1">Guides & formulaires</span>
											<i className="eva eva-arrow-down fs-root lh-1 align-middle"></i>
										</span>
									</button>
									<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:NOTAIRE - Dossier Succession.pdf"))}>
											<span className="ls-n3">Dossier des pièces à joindre lors d'une succession avec notaire (succession de + 5 965 €)</span>
										</button>
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:SANS NOTAIRE - Attestation sur lhonneur des heritiers.pdf"))}>
											<span className="ls-n3">Attestation sur l'honneur des héritiers et porte-fort pour les démarches (sans notaire - 5 965 €)</span>
										</button>

										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:SANS NOTAIRE - Demande FCDDV.pdf"))}>
											<span className="ls-n3">Demande de certificat d'absence de dispositions de dernières volontés (sans notaire)</span>
										</button>

										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:SANS NOTAIRE - FICOBA.pdf"))}>
											<span className="ls-n3">Demande FICOBA (sans notaire)</span>
										</button>
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:SANS NOTAIRE - FICOVIE.pdf"))}>
											<span className="ls-n3">Demande FICOVIE (sans notaire)</span>
										</button>

										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:Demandes acte de naissance pour PDR.pdf"))}>
											<span className="ls-n3">Demande acte de naissance (dossier de réversion et sans notaire)</span>
										</button>
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:DPR - Salaries et independants - CARSAT MSA CAVIMC CNAPVL.pdf"))}>
											<span className="ls-n3">Formulaire de demande de réversion salariés, indépendants et professions libérales - CARSAT MSA CAVIMAC CNAVPL (régime de base)</span>
										</button>
										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => window.open(retraiteComplementaireLink)}>
											<span className="ls-n3">Formulaire de demande de pension de reversion AGIRC ARRCO régime complémentaire </span>
										</button>
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:AIDE - CPAM - Demande de Capital Deces.pdf"))}>
											<span className="ls-n3">Formulaire de demande de capital décès</span>
										</button>
										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:AIDE - CR - Demande dallocation de solidarite aux personnes agees (ASPA).pdf"))}>
											<span className="ls-n3">Formulaire de demande d'allocation de solidarité aux personnes âgées (ASPA)</span>
										</button>
										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:AIDE - CR - Demande d aide a l autonomie a domicile pour les personnes agees (APA).pdf"))}>
											<span className="ls-n3">Formulaire de demande d'aide à l'autonomie à domicile pour les personnes âgées (APA)</span>
										</button>
										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:CarteGrise.pdf"))}>
											<span className="ls-n3">Demande concernant la carte grise</span>
										</button>

										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:Particulier employeur.pdf"))}>
											<span className="ls-n3">Particulier employeur</span>
										</button>

										<button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => window.open(mesDroitsSociauxLink)}>
											<span className="ls-n3">Demande d'aides et allocations : Mes droits sociaux</span>
										</button>

										{/* <button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:ReversionEnLigne.pdf"))}>
											<i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
											<span className="ls-n3">Demande de réversion en ligne regime de base salarié</span>
										</button> */}

										{/* <button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:SANS NOTAIRE - Attestation porte-fort.pdf"))}>
											<i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
											<span className="ls-n3">Attestation porte-fort (sans notaire)</span>
										</button> */}

										{/* <button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:succession.pdf"))}>
                                        <span className="ls-n3">Guide succession</span>
                                    </button>
                                    <button type="button" className="w-100 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" onClick={() => dispatch(downloadDocument(userId, "GUIDE:ActeDeNaissance.pdf"))}>
                                        <span className="ls-n3">Acte de naissance</span>
                                    </button> */}
									</div>
								</div>
								<button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none" data-toggle="modal" data-target="#partager" disabled={R.isEmpty(selectedFileNames)}>
									<i className="btn-icon eva eva-undo-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
									<span className="btn-text px-3">Partager</span>
								</button>
							</div>
							{/* <button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none ml-1" onClick={() => dispatch(downloadDocument(userId, "guide"))}>
                            <i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
                            <span className="btn-text px-3">Guide succession</span>
                        </button> */}
							<ModalPartager fileNames={selectedFileNames} userId={userId} userRepresentativeId={userRepresentativeId} isLoading={isLoading} />
						</div>
						{/* <div className="flex-row gap-2 flex-wrap mb-3">
                        <button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none" onClick={() => dispatch(downloadDocument(userId, "guide"))}>
                            <i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
                            <span className="btn-text px-3">Guide succession</span>
                        </button>
                        <button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none" onClick={() => window.open(retraiteBaseLink)}>
                            <i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
                            <span className="btn-text px-3">Réversion retraite de base</span>
                        </button>
                        <button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none" onClick={() => window.open(retraiteComplementaireLink)}>
                            <i className="btn-icon eva eva-info-outline eva-flip-h btn-white-info text-info rounded btn-square no-event"></i>
                            <span className="btn-text px-3">Formulaire retraite complémentaire</span>
                        </button>
                    </div> */}
					</header>
					<hr className="mb-4" />
					<section className="flex-column mb-4">
						<h2 className="fs-3 font-weight-bolder text-uppercase ls-2 o-60">Documents Utiles</h2>
						<form className="grid grid-sm-narrow grid-xl-2 grid-hd-4 pb-sm">
							<UploadArea
								documentName={FiletypeToDisplayName(FileTypes.UserIdCard)}
								uploadedFile={files.find((x) => x.fileType === FileTypes.UserIdCard)}
								uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserIdCard, document, description))}
								downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
								// deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
								deleteFile={(document) => {
									setSelectedElementToDelete(document);
									$("#deleteDoc").modal("show");
								}}
								selectable={true}
								selectedFiles={selectedFileNames}
								setSelectFiles={setSelectedFileNames}
								editDescription={(document) => {
									setSelectedElementToEdit(document);
									$("#ModalFileDescription").modal("show");
								}}
							/>
							<UploadArea
								documentName={FiletypeToDisplayName(FileTypes.UserFamilyRecordBook)}
								uploadedFile={files.find((x) => x.fileType === FileTypes.UserFamilyRecordBook)}
								uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserFamilyRecordBook, document, description))}
								downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
								deleteFile={(document) => {
									setSelectedElementToDelete(document);
									$("#deleteDoc").modal("show");
								}}
								selectable={true}
								selectedFiles={selectedFileNames}
								setSelectFiles={setSelectedFileNames}
								editDescription={(document) => {
									setSelectedElementToEdit(document);
									$("#ModalFileDescription").modal("show");
								}}
							/>
							<UploadArea
								documentName={FiletypeToDisplayName(FileTypes.UserDonation)}
								uploadedFile={files.find((x) => x.fileType === FileTypes.UserDonation)}
								uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.UserDonation, document, description))}
								downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
								deleteFile={(document) => {
									setSelectedElementToDelete(document);
									$("#deleteDoc").modal("show");
								}}
								selectable={true}
								selectedFiles={selectedFileNames}
								setSelectFiles={setSelectedFileNames}
								editDescription={(document) => {
									setSelectedElementToEdit(document);
									$("#ModalFileDescription").modal("show");
								}}
							/>
							{/* <UploadArea documentName={"Télécharger"} labelName={"Avancer les procédures requises en déposant les documents..."} modalTelechargerArea={false} toggleTelechargerArea={true} telechargerArea={true} documentType={FileTypes.Other}
                            uploadFile={(document, description) => dispatch(uploadDocument(userId, FileTypes.Other, document, description))}
                            downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
                            deleteFile={(document) => dispatch(deleteDocument(userId, document.fileName))}
                            selectable={true}
                            selectedFiles={selectedFileNames}
                            setSelectFiles={setSelectedFileNames}
                        /> */}
							{files
								.filter((file) => file.fileType !== FileTypes.UserIdCard && file.fileType !== FileTypes.UserFamilyRecordBook && file.fileType !== FileTypes.UserDonation && file.fileType !== FileTypes.Other && file.fileType !== FileTypes.Folder)
								.map((file, index) => {
									return (
										<UploadArea
											documentName={FiletypeToDisplayName(file.fileType)}
											uploadedFile={file}
											uploadFile={(document, description) => dispatch(uploadDocument(userId, file.fileType, document, description))}
											downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName))}
											deleteFile={(document) => {
												setSelectedElementToDelete(document);
												$("#deleteDoc").modal("show");
											}}
											selectable={true}
											selectedFiles={selectedFileNames}
											setSelectFiles={setSelectedFileNames}
											key={file.fileName + index}
											editDescription={(document) => {
												setSelectedElementToEdit(document);
												$("#ModalFileDescription").modal("show");
											}}
										/>
									);
								})}
							<div className="card py-3 border-0 shadow-xs--hover rounded upload-card btn-alert-secondary" data-toggle="modal" data-target="#fichier" onClick={(e) => setModalForDefaultData(true)}>
								<div className="card-body flex-row gap-3 my-auto py-0" role="button">
									<div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-white text-secondary">
										<i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
									</div>
									<div className="flex-column flex-fill my-auto">
										<h3 className="fs-root mb-0 lh-copy my-auto">Télécharger</h3>
										<p className="small o-60 mb-0 lh-copy my-auto container-up">Charger un document utile</p>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="flex-column">
						<div className="flex-row gap-3 mb-3">
							<div className="flex-column gap-1">
								<h2 className="fs-3 font-weight-bolder text-uppercase ls-2 o-60 my-auto">Dossiers personnalisés</h2>
								<div className="flex-row align-items-center gap-2">
									<h2
										className="fs-1 font-weight-bolder text-uppercase ls-2 my-auto o-40 o-100--hover"
										role="button"
										onClick={(e) => {
											browseFolder();
										}}>
										<i className="eva eva-arrow-right fs-root lh-1 align-middle mr-1"></i>
										<span className="align-middle">Racine</span>
									</h2>
									{path.map((part) => {
										return (
											<React.Fragment key={part.fullPath}>
												<span className="my-auto o-20">/</span>
												<h2
													className={"fs-1 font-weight-bolder text-uppercase ls-2 my-auto" + (R.isNil(pathLastElement) || part.fullPath === pathLastElement.fullPath ? " o-80 text-aux" : " o-40 o-100--hover")}
													role="button"
													onClick={(e) => {
														browseFolder(part.fullPath);
													}}>
													{/* <i className="eva eva-folder-outline fs-root lh-1 align-middle mr-1"></i> */}
													<span className="align-middle">{part.folderName}</span>
												</h2>
											</React.Fragment>
										);
									})}
								</div>
							</div>
							<div className="flex-row gap-2 my-auto ml-auto">
								<div className="btn-group">
									<button type="button" className="btn btn-alert-aux btn-if p-1 rounded border-none" data-toggle="dropdown" aria-expanded="false">
										<i className="btn-icon eva eva-plus-outline fs-root lh-1 btn-white-warning text-aux rounded btn-square no-event"></i>
										<span className="btn-text px-3">
											<span className="align-middle mr-1">Nouveau</span>
											<i className="eva eva-arrow-down fs-root lh-1 align-middle"></i>
										</span>
									</button>
									<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#ModalEditFolder">
											<i className="eva eva-folder-outline mr-2"></i>
											<span className="ls-n3">Dossier</span>
										</button>
										<button type="button" className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none" data-toggle="modal" data-target="#fichier" onClick={(e) => setModalForDefaultData(false)}>
											<i className="eva eva-file-outline mr-2"></i>
											<span className="ls-n3">Fichier</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<Dropzone
							onDrop={(acceptedFiles) => {
								if (!R.isEmpty(acceptedFiles)) {
									setDraggedFiles(
										acceptedFiles.map((f) => {
											f.description = null;
											f.fileType = FileTypes.Other;
											return f;
										})
									);
									$("#fichier").modal("show");
								}
							}}
							onDropRejected={(filesErrors) => {
								filesErrors.map((fileErrors) =>
									fileErrors.errors.map((error) => {
										if (error.code === "file-invalid-type") {
											toast.error(`Le fichier '${fileErrors.file.name}' n'est pas un fichier PDF.`, ToasterConfigurations);
										}
									})
								);
							}}
							noClick={true}
							accept={"application/pdf"}>
							{({ isDragActive, getRootProps, getInputProps }) =>
								personalFiles.length === 0 ? (
									<article {...getRootProps({ className: "flex-column px-3 py-5 my-3 h-100" + (isDragActive ? " dropzone-focused" : "") })}>
										<input {...getInputProps()} />
										<div className="container container-base text-center m-auto">
											<h5 className="sr-only visually-hidden">Biblioteque - Empty</h5>
											<img className="img-fluid mx-auto container-md-narrow mb-3 img-blend" src={servicesUploading} alt="features overview" />
											<h1 className="h1 font-weight-black ls-n3 lh-1 mb-1">Déposez vos fichiers ici.</h1>
											<p className="fs-default mb-4 o-60">ou utilisez le bouton "télécharger"</p>
											<button type="button" className="btn btn-alert-info btn-if p-1 rounded border-none ml-auto" data-toggle="modal" data-target="#fichier" disabled="" onClick={(e) => setModalForDefaultData(false)}>
												<i className="btn-icon eva eva-cloud-upload-outline btn-white-info text-info rounded btn-square no-event fs-root"></i>
												<span className="btn-text px-3">Télécharger</span>
											</button>
										</div>
									</article>
								) : (
									<article {...getRootProps({ className: "flex-column mx-nsm" + (isDragActive ? " dropzone-focused" : "") })}>
										<input {...getInputProps()} />
										<section className="grid grid-sm-narrow grid-xl-2 grid-hd-4 p-sm">
											{personalFiles
												.filter((x) => x.fileType === FileTypes.Other || x.fileType === FileTypes.Folder)
												.map((file) => {
													if (file.fileType === FileTypes.Folder) {
														const folderFullName = (R.isNil(pathLastElement) ? "" : pathLastElement.fullPath + "/") + file.fileName;
														return (
															<div className="card border-0 rounded upload-card bg-mix bg-light--hover" key={file.fileName}>
																<div className="card-body flex-column gap-2 my-auto">
																	<div className="flex-row flex-grow-1 gap-3 justify-content-between my-auto">
																		<h3 className="fs-1 o-60 my-auto text-uppercase font-weight-bold ls-2">Dossier</h3>
																		<div className="custom-control custom-checkbox checkbox-cc ml-auto mr-n1">
																			<input
																				type="checkbox"
																				className="custom-control-input"
																				id={file.fileName}
																				onChange={() => {
																					if (selectedFileNames.indexOf(folderFullName + "/*") === -1) {
																						setSelectedFileNames([...selectedFileNames, folderFullName + "/*"]);
																					} else {
																						setSelectedFileNames(selectedFileNames.filter((s) => s !== folderFullName + "/*"));
																					}
																				}}
																			/>
																			<label className="custom-control-label text-none border-gray fs-0 ml-1" htmlFor={file.fileName}>
																				Select
																			</label>
																		</div>
																	</div>
																	<div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
																		<div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-dim">
																			<i className="eva eva-folder-outline h1 lh-1 m-auto o-60"></i>
																		</div>
																		<div
																			className="flex-column flex-fill my-auto"
																			onClick={(e) => {
																				e.preventDefault();
																				browseFolder(folderFullName);
																			}}>
																			<h3 className="fs-root mb-0 lh-copy my-auto">{file.fileName}</h3>
																			{/* <p className="small o-60 mb-0 lh-copy my-auto">10 documents</p> */}
																		</div>
																		<div className="btn-group">
																			<button type="button" className="btn btn-square btn-mix text-inherit border-0 rounded-sm my-auto flex-shrink-0" data-toggle="dropdown" aria-expanded="false">
																				<i className="eva eva-more-vertical-outline fs-root lh-1 align-middle"></i>
																			</button>
																			<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
																				<button
																					type="button"
																					className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
																					data-toggle="modal"
																					data-target="#deleteDoc"
																					onClick={(e) => {
																						setSelectedElementToDelete(file);
																					}}>
																					<span className="ls-n3">Supprimer dossier</span>
																				</button>
																				<button
																					type="button"
																					className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
																					onClick={(e) => {
																						e.preventDefault();
																						browseFolder((R.isNil(pathLastElement) ? "" : pathLastElement.fullPath + "/") + file.fileName);
																					}}>
																					<span className="ls-n3">Voir dossier</span>
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														);
													} else {
														file.path = currentPath;
														return (
															<UploadArea
																key={file.fileName}
																documentName={file.fileName}
																documentType={file.fileType}
																uploadedFile={file}
																uploadFile={(document, description) => dispatch(uploadDocument(userId, file.fileType, document, description))}
																downloadFile={(document) => dispatch(downloadDocument(userId, document.fileName, currentPath))}
																deleteFile={(document) => {
																	setSelectedElementToDelete(document);
																	$("#deleteDoc").modal("show");
																}}
																selectable={true}
																selectedFiles={selectedFileNames}
																setSelectFiles={setSelectedFileNames}
																editDescription={(document) => {
																	setSelectedElementToEdit(document);
																	$("#ModalFileDescription").modal("show");
																}}
															/>
														);
													}
												})}
										</section>
									</article>
								)
							}
						</Dropzone>
					</section>
				</div>
				<ModalConfirmation />

				<ModalAddFile userId={userId} currentPath={currentPath} onFileAdded={() => browseFolder(currentPath)} isDefaultFiles={modalForDefaultData} isFacilita={true} injectedFiles={draggedFiles} />
				<ModalEditFolder userId={userId} currentPath={currentPath} onFolderEdited={() => browseFolder(currentPath)} />
				<ModalDelete userId={userId} elementToDelete={selectedElementToDelete} currentPath={currentPath} onFileDelete={() => browseFolder(currentPath)} isFacilita={true} />
				<ModalFileDescription userId={userId} currentPath={currentPath} onDocumentEdited={() => browseFolder(currentPath)} document={selectedElementToEdit} />
			</article>
		);
};